import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { apiOrigin } from '@/utils/apiBase';

const API_URL = apiOrigin();

const LanguageContext = createContext();

const fallback = {};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('hc_lang') || 'en');
  const [translations, setTranslations] = useState(fallback);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/settings/translations/${lang}`);
        setTranslations(res.data);
      } catch (e) {
        console.error('Failed to load translations:', e);
      }
      setLoaded(true);
    };
    load();
  }, [lang]);

  const changeLang = useCallback((newLang) => {
    setLang(newLang);
    localStorage.setItem('hc_lang', newLang);
  }, []);

  const t = useCallback((key) => {
    return translations[key] || key;
  }, [translations]);

  return (
    <LanguageContext.Provider value={{ lang, changeLang, t, loaded }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}
